import React, { useEffect, useState } from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import { useDispatch } from 'react-redux';

import { ReportApiService } from 'Services/ApiServices';
import { setLoader } from 'Store/Actions/Loading/LoadingAction';
import { toastr } from 'Helpers/ToastHelper';
import StatusAllAgGridTable from 'Views/All/AgGridTable/StatusAllAgGridTable';

const StatusOverview = () => {
  const dispatch = useDispatch();

  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  const createExcelReport = async () => {
    try {
      dispatch(setLoader(true));
      const data = await ReportApiService.createExcelReport();
      if (data.message === 'Processing') {
        toastr.warning(
          'Processing',
          "Your report is now processing. You will soon receive it via email. The export button is now disabled for 2' to generate the file."
        );
      }
      setIsButtonDisabled(true);
      const disabledUntil = new Date(new Date().getTime() + 120000);
      localStorage.setItem('disabledUntil', disabledUntil);
      setTimeout(() => {
        setIsButtonDisabled(false);
        localStorage.removeItem('disabledUntil');
      }, 120000);
    } catch (error) {
      toastr.error('Error', error?.message || 'An error occurred while generating the report.');
    } finally {
      dispatch(setLoader(false));
    }
  };

  useEffect(() => {
    document.title = 'F2W - Overview';
    const disabledUntil = localStorage.getItem('disabledUntil');
    if (disabledUntil) {
      const timeLeft = new Date(disabledUntil).getTime() - new Date().getTime();
      if (timeLeft > 0) {
        setIsButtonDisabled(true);
        setTimeout(() => {
          setIsButtonDisabled(false);
          localStorage.removeItem('disabledUntil');
        }, timeLeft);
      }
    }
  }, []);

  return (
    <React.Fragment>
      <Row>
        <Col style={{ display: 'flex', alignItems: 'center' }}>
          <h4>Overview</h4>

          <Button
            variant="primary"
            size="sm"
            style={{ marginLeft: '15px', padding: '0px 12px', fontSize: '0.875rem' }}
            onClick={() => {
              createExcelReport();
            }}
            disabled={isButtonDisabled}
          >
            Export excel report
          </Button>
        </Col>
      </Row>
      <StatusAllAgGridTable />
    </React.Fragment>
  );
};

export default StatusOverview;
